module.exports = __webpack_public_path__ + "static/media/curriculum_pt.cd9a6576.pdf";